import React from 'react'

export default function OrgRecording() {
  return (
    <div>OrgRecording</div>
  )
}
